export class ConstantValue {
    static fromEnumDisplayMap(enumDisplayMap: Map<string, string>): ConstantValue[] {
        return Array.from(enumDisplayMap.keys()).map((key: string) => {
            return new ConstantValue(key, enumDisplayMap.get(key));
        });
    }
    static fromArray(array: string[]): ConstantValue[] {
        return array.map((key: string) => {
            return new ConstantValue(key, key);
        });
    }
    static fromKeyValueObject(object: any): ConstantValue[] {
        return Object.keys(object).map((key: string) => {
            return new ConstantValue(key, object[key]);
        });
    }
    constructor(public objectValue: string, public displayValue: string) {

    }
}
